var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"filter-container detail-back"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-back"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }